import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { useCurrencies } from '../../context/CurrencyContext';
import { useLocale } from '../../context/LocaleContext';
import { currencySymbol } from '../../lib/constants';
import { uiText } from '../../lib/i18n';

export const CustomerCurrencySelect = ({ currency, onChange, prefix = 'customer-currency', disabled = false }) => {
  const { codes } = useCurrencies();
  const { locale } = useLocale();
  const name = code => {
    try { if (Intl.DisplayNames) return new Intl.DisplayNames([locale], { type: 'currency' }).of(code); } catch { /* Older mobile browsers keep a translated fallback. */ }
    return uiText({ EUR: 'Euro', USD: 'US Dollar', TRY: 'Turkish Lira', GBP: 'British Pound' }[code] || code);
  };
  return <Select value={currency} onValueChange={onChange} disabled={disabled}>
    <SelectTrigger data-testid={`${prefix}-selector`} aria-label="Currency" className="customer-currency-dropdown"><SelectValue><span>{currencySymbol(currency)} {currency}</span></SelectValue></SelectTrigger>
    <SelectContent data-testid={`${prefix}-options`}>{codes.map(code => <SelectItem key={code} value={code} data-testid={`${prefix}-option-${code.toLowerCase()}`}>{code} — {name(code)}</SelectItem>)}</SelectContent>
  </Select>;
};